(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["magnum-product-cutout-fix"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.mgnProductCutoutFixReady) return;
    window.mgnProductCutoutFixReady = true;

    const targetHandles = new Set([
      "ca-dei-frati-spumante-rose-cuvee-dei-frati-magnum",
      "molin-lugana-dop",
      "ronchedone",
    ]);
    const quantSize = 16;
    const pixelIndex = (x, y, width) => (y * width + x) * 4;

    const getHandleFromUrl = (href) => {
      try {
        const url = new URL(href, window.location.href);
        const match = url.pathname.match(/\/products\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]).toLowerCase() : "";
      } catch (error) {
        const match = String(href).match(/\/products\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]).toLowerCase() : "";
      }
    };

    const candidateTolerance = (candidate) => {
      const brightness = (candidate[0] + candidate[1] + candidate[2]) / 3;
      if (brightness < 36) return 24 * 24;
      if (brightness > 218) return 42 * 42;
      return 46 * 46;
    };

    const addSample = (counts, data, index) => {
      if (data[index + 3] < 24) return;
      const key = [
        Math.round(data[index] / quantSize),
        Math.round(data[index + 1] / quantSize),
        Math.round(data[index + 2] / quantSize),
      ].join(",");
      counts.set(key, (counts.get(key) || 0) + 1);
    };

    const buildCandidates = (data, width, height) => {
      const counts = new Map();
      const step = Math.max(1, Math.floor(Math.min(width, height) / 160));

      for (let x = 0; x < width; x += step) {
        addSample(counts, data, pixelIndex(x, 0, width));
        addSample(counts, data, pixelIndex(x, height - 1, width));
      }

      for (let y = 0; y < height; y += step) {
        addSample(counts, data, pixelIndex(0, y, width));
        addSample(counts, data, pixelIndex(width - 1, y, width));
      }

      return [...counts.entries()]
        .sort((a, b) => b[1] - a[1])
        .slice(0, 8)
        .map(([key]) =>
          key.split(",").map((value) => Math.min(255, Number(value) * quantSize))
        );
    };

    const matchesBackground = (data, index, candidates) => {
      if (data[index + 3] < 24) return true;

      for (const candidate of candidates) {
        const red = data[index] - candidate[0];
        const green = data[index + 1] - candidate[1];
        const blue = data[index + 2] - candidate[2];

        if (red * red + green * green + blue * blue <= candidateTolerance(candidate)) {
          return true;
        }
      }

      return false;
    };

    const removeBackground = (canvas, context, width, height) => {
      const imageData = context.getImageData(0, 0, width, height);
      const { data } = imageData;
      const candidates = buildCandidates(data, width, height);
      if (!candidates.length) return false;

      const marked = new Uint8Array(width * height);
      const queue = [];
      let read = 0;

      const enqueue = (x, y) => {
        if (x < 0 || y < 0 || x >= width || y >= height) return;
        const position = y * width + x;
        if (marked[position]) return;
        if (!matchesBackground(data, position * 4, candidates)) return;
        marked[position] = 1;
        queue.push(position);
      };

      for (let x = 0; x < width; x += 1) {
        enqueue(x, 0);
        enqueue(x, height - 1);
      }

      for (let y = 0; y < height; y += 1) {
        enqueue(0, y);
        enqueue(width - 1, y);
      }

      while (read < queue.length) {
        const position = queue[read];
        read += 1;
        const x = position % width;
        const y = (position - x) / width;
        enqueue(x + 1, y);
        enqueue(x - 1, y);
        enqueue(x, y + 1);
        enqueue(x, y - 1);
      }

      if (queue.length < width * 2 + height * 2) return false;

      for (let position = 0; position < marked.length; position += 1) {
        if (marked[position]) data[position * 4 + 3] = 0;
      }

      context.putImageData(imageData, 0, 0);
      return true;
    };

    const processImage = (image) => {
      if (image.dataset.mgnProductCutout === "processing" || image.dataset.mgnProductCutout === "done") return;
      image.dataset.mgnProductCutout = "processing";

      const source = image.currentSrc || image.src;
      if (!source) {
        image.dataset.mgnProductCutout = "failed";
        return;
      }

      const sourceImage = new Image();
      sourceImage.crossOrigin = "anonymous";
      sourceImage.decoding = "async";

      sourceImage.onload = () => {
        const width = sourceImage.naturalWidth;
        const height = sourceImage.naturalHeight;

        if (!width || !height) {
          image.dataset.mgnProductCutout = "failed";
          return;
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const context = canvas.getContext("2d", { willReadFrequently: true });
        if (!context) {
          image.dataset.mgnProductCutout = "failed";
          return;
        }

        try {
          context.drawImage(sourceImage, 0, 0);

          if (!removeBackground(canvas, context, width, height)) {
            image.dataset.mgnProductCutout = "failed";
            return;
          }

          canvas.toBlob((blob) => {
            if (!blob) {
              image.dataset.mgnProductCutout = "failed";
              return;
            }

            const url = URL.createObjectURL(blob);
            image.dataset.mgnProductCutout = "done";
            image.removeAttribute("srcset");
            image.removeAttribute("sizes");
            image.classList.add("mgn-product-cutout-ready");
            image.addEventListener("load", () => URL.revokeObjectURL(url), { once: true });
            image.src = url;
          }, "image/png");
        } catch (error) {
          image.dataset.mgnProductCutout = "failed";
        }
      };

      sourceImage.onerror = () => {
        image.dataset.mgnProductCutout = "failed";
      };

      sourceImage.src = source;
    };

    const processCardImages = () => {
      document.querySelectorAll("a.mgn-card[href]").forEach((card) => {
        const handle = getHandleFromUrl(card.getAttribute("href"));
        if (!targetHandles.has(handle)) return;

        const image = card.querySelector(".mgn-card__bottle img");
        if (!image) return;

        card.classList.add("mgn-product-cutout-card");
        if (image.complete && image.naturalWidth) {
          processImage(image);
        } else {
          image.addEventListener("load", () => processImage(image), { once: true });
        }
      });
    };

    const processProductGallery = () => {
      const currentHandle = getHandleFromUrl(window.location.href);
      if (!targetHandles.has(currentHandle)) return;

      document.querySelectorAll(".product-media-gallery-frame").forEach((gallery) => {
        gallery.classList.add("mgn-product-cutout-gallery");
      });

      document
        .querySelectorAll(".magnum-product-gallery-frame img, .product-media-gallery-frame img, media-gallery img")
        .forEach((image) => {
          if ((image.getAttribute("alt") || "").toLowerCase() === "expertise") return;

          if (image.complete && image.naturalWidth) {
            processImage(image);
          } else {
            image.addEventListener("load", () => processImage(image), { once: true });
          }
        });
    };

    const init = () => {
      processCardImages();
      processProductGallery();
    };

    let queued = false;
    const scheduleInit = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        init();
      });
    };

    document.addEventListener("DOMContentLoaded", init);
    document.addEventListener("shopify:section:load", init);
    init();

    if (document.body) {
      new MutationObserver(scheduleInit).observe(document.body, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
